export type Rijtijd = {
    beginStation: string;
    eindStation: string;
    reisMinuten?: number;
};

export const Rijtijd = {
    getTotaleRijtijd(rijtijden: Rijtijd[]): number | undefined {
        if (rijtijden.length === 0) return undefined;
        if (rijtijden.some((r) => r.reisMinuten == null)) return undefined;
        return rijtijden.reduce((sum, r) => sum + r.reisMinuten!, 0);
    },

    /** Human-readable format: "30 min", "1u 30 min", "2u" */
    formatRijtijd(rijtijdMinuten: number | undefined): string {
        if (rijtijdMinuten === undefined) return "-- min";
        if (rijtijdMinuten < 60) return `${rijtijdMinuten} min`;
        const uren = Math.floor(rijtijdMinuten / 60);
        const minuten = rijtijdMinuten % 60;
        return minuten > 0 ? `${uren}u ${minuten} min` : `${uren}u`;
    },

    /** Digital clock format: "01:30", "02:00" */
    formatSegmentRijtijd(minutes: number): string {
        const h = Math.floor(minutes / 60);
        const m = Math.floor(minutes % 60);
        return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
    },

    /** Parse user input to total minutes. Accepts: h:mm, hh:mm, hh, hhmm, etc. Returns null if invalid. */
    parseSegmentRijtijd(value: string): number | null {
        const trimmed = value.trim();

        if (trimmed.includes(":")) {
            const [hPart, mPart] = trimmed.split(":");
            if (!hPart || !mPart || !/^\d{1,2}$/.test(hPart) || !/^\d{1,2}$/.test(mPart)) return null;
            const m = parseInt(mPart);
            if (m >= 60) return null;
            return parseInt(hPart) * 60 + m;
        }

        if (!/^\d{1,4}$/.test(trimmed)) return null;

        // First 1-2 digits are always hours, remaining digits are minutes
        const h = parseInt(trimmed.slice(0, 2));
        const m = trimmed.length > 2 ? parseInt(trimmed.slice(2)) : 0;
        if (m >= 60) return null;
        return h * 60 + m;
    },
};
